import {
  SET_ONBOARDER,
  REGISTER_SUCCESS,
  CLEAR_ONBOARDER,
  GOOGLE_SIGN_UP,
  FACEBOOK_SIGN_UP
} from "../actions/actiontypes";
const initState = {
  onboarder: {
    token: localStorage.getItem("token"),
  },
};

const onboarderReducer = (state = initState, action) => {
  switch (action.type) {
    case SET_ONBOARDER:
      return {
        ...state,
        onboarder: {
          ...state.onboarder,
          [action.payload[0]]: action.payload[1],
        },
      };

    case REGISTER_SUCCESS:
      const { token } = action;
      return {
        ...state,
        onboarder: {
          ...state.onboarder,
          token,
        },
      };
      case GOOGLE_SIGN_UP:
        return {
          ...state,
          onboarder: {
            emailVerified: true,
            accountCreated: true,
            ...action.payload,
          },
        };
      case FACEBOOK_SIGN_UP:
        return {
          ...state,
          onboarder: {
            emailVerified: true,
            accountCreated: true,
            ...action.payload,
          },
        };
    case CLEAR_ONBOARDER:
      return {
        ...state,
        onboarder: {},
      };
    default:
      break;
  }
  return state;
};
export default onboarderReducer;
